import { addIntersectionItem } from '../util'

let loaded = false

export function gmap(selector = '.js-map', context = document) {
    const mapElement = context.querySelector(selector)
    if (!mapElement) {
        return
    }

    if (typeof window.google !== 'undefined') {
        initMap(mapElement)
        return
    }

    addIntersectionItem(mapElement, ({ el }, entry) => {
        if (loaded || !entry.isIntersecting) {
            return
        }

        loaded = true
        loadjs(
            [
                '//maps.googleapis.com/maps/api/js' // ?key=
            ],
            {
                success: () => {
                    initMap(el)
                },
                before: (path, scriptEle) => {
                    const nonceTag = document.querySelector('meta[name="csp-nonce"]')

                    if (nonceTag) {
                        scriptEle.setAttribute('nonce', nonceTag.content)
                    }
                }
            }
        )
    })
}

function initMap(selector) {
    if (typeof window.google === 'undefined') {
        setTimeout(() => {
            initMap(selector)
        }, 1250)
        return
    }

    const mapElements = document.querySelector('.js-map')
    if (!mapElements) {
        return
    }

    const { lat, lng } = mapElements.dataset

    const { Map, Marker } = window.google.maps
    const latLng = {
        lat: +lat || 51.2352025,
        lng: +lng || -1.119185
    }
    let center = {
        lat: latLng.lat,
        lng: latLng.lng
    }
    if (window.innerWidth <= 786) {
        center = latLng
    }
    const customIcon = {
        path:
            'M7,0C3.1,0,0,3.1,0,7s7,13,7,13s7-9.1,7-13S10.9,0,7,0z M7,9.75C5.46,9.75,4.25,8.54,4.25,7S5.46,4.25,7,4.25S9.75,5.46,9.75,7S8.54,9.75,7,9.75z',
        anchor: new window.google.maps.Point(7, 20),
        fillColor: '#4f4e56',
        fillOpacity: 1,
        scale: 2.5,
        strokeOpacity: 0
    }

    const map = new Map(mapElements, {
        zoom: 15,
        center: center,
        scrollwheel: false,
        gestureHandling: 'cooperative'
    })

    new Marker({
        position: latLng,
        map,
        title: 'Benyon Estate',
        icon: customIcon
    })
}
window.initMap = initMap
